export const REPORTS_SIGNUP_WALL_EXPERIMENT = "reports_signup_wall"
export const REPORTS_SIGNUP_WALL_VARIANT = "signup_wall"

/** Brief free-reading window before the wall appears for the signup_wall arm. */
export const REPORTS_SIGNUP_WALL_REVEAL_DELAY_MS = 4500

export interface ReportsSignupWallProps {
  experimentUrl: string
  contentSelector: string
  signUpUrl: string
  signInUrl: string
  heading: string
  description: string
  benefits: string[]
  experimentName?: string
  signupWallVariant?: string
  /** When false, never fetch/enroll — signed-in users must stay out of the experiment. */
  signedOut?: boolean
  /** Milliseconds to let guests read before showing the wall. */
  revealDelayMs?: number
  /** When true, skip assignment and always show the shipped signup wall. */
  shipped?: boolean
}

export interface FieldTestAssignmentResponse {
  experiment: string
  variant: string | null
  enrolled: boolean
}
